// ============================================================
// Intent tags — l'axe QUAND (Sprint 8, 2026-05-26).
//
// Avant : "expat-soon" et "curious" vivaient dans /data/personas.js
// comme des personas, ce qui créait des doublons (un retraité peut
// très bien être en move-soon). Maintenant ils sont des TAGS d'horizon,
// superposables à n'importe quelle persona.
// ============================================================

/**
 * @typedef {'move-soon'|'planning'|'exploring'} IntentSlug
 */

export const INTENTS = {
  'move-soon': {
    slug: 'move-soon',
    horizon: '< 12 mois',
    horizonRangeMonths: [0, 12],
    label: { fr: 'Bientôt', en: 'Soon', es: 'Pronto' },
    sub: {
      fr: 'Je pars dans moins d\'un an',
      en: 'Moving within 12 months',
      es: 'Me voy en menos de un año',
    },
    designEffect: {
      productPush: 'dominant',     // CTA produit / consulting en avant
      contentDensity: 'high',       // checklists, partenaires pré-vérifiés
      newsletterRole: 'support',    // capture email = sous-élément
    },
  },
  planning: {
    slug: 'planning',
    horizon: '6-24 mois',
    horizonRangeMonths: [6, 24],
    label: { fr: 'Planification', en: 'Planning', es: 'Planeando' },
    sub: {
      fr: 'Je planifie entre 6 et 24 mois',
      en: 'Planning 6-24 months ahead',
      es: 'Planeando entre 6 y 24 meses',
    },
    designEffect: {
      productPush: 'mix',           // mix contenu / capture / low-ticket
      contentDensity: 'medium',
      newsletterRole: 'primary',
    },
  },
  exploring: {
    slug: 'exploring',
    horizon: '2-5 ans',
    horizonRangeMonths: [24, 60],
    label: { fr: 'Exploration', en: 'Exploring', es: 'Explorando' },
    sub: {
      fr: 'Je découvre, échéance lointaine',
      en: 'Just exploring, no rush',
      es: 'Solo exploro, sin prisa',
    },
    designEffect: {
      productPush: 'none',          // ZÉRO push produit
      contentDensity: 'narrative',  // narratif, sensoriel
      newsletterRole: 'primary',
    },
  },
};

export const INTENT_SLUGS = ['move-soon', 'planning', 'exploring'];

export function getIntent(slug) {
  if (!slug) return null;
  return INTENTS[slug] || null;
}
